import { formatDate, parse } from 'core/utils/date'

import { type ShipperAttachment, type AttachmentDocumentType } from '../domain/Document'

const documentTypeLabels: Record<AttachmentDocumentType, string> = {
  certificate_of_insurance: 'COI',
  w9: 'W9',
  other: 'Other',
  client_contract: 'Client Contract',
}

function getDocumentTypeLabel(documentType: AttachmentDocumentType): string {
  return documentTypeLabels[documentType]
}

export function formatShipperAttachmentLabel(
  attachment: Pick<ShipperAttachment, 'documentType' | 'expirationDate'>
): string {
  const { documentType, expirationDate } = attachment
  const typeLabel = getDocumentTypeLabel(documentType)

  if (!expirationDate) {
    return typeLabel
  }

  const formattedExpirationDate = formatDate(
    parse(expirationDate, 'yyyy-MM-dd', new Date()),
    'MMM d, yyyy'
  )

  return `${typeLabel} (expire date: ${formattedExpirationDate})`
}
